// src/components/wizard/WizardWelcome.jsx
// Covers: PL-04 (rotating challenge phrases)

import React, { useState, useEffect } from 'react';
import styles from './WizardStep.module.css';

const PHRASES = [
  'adjusting to life after service',
  'your spouse\'s PTSD',
  'finding work after release',
  'housing after a medical release',
  'connecting your family to support',
  'navigating VAC benefits',
  'peer support after deployment',
  'rehabilitation after injury',
  'financial assistance as a Veteran',
  'supporting a child of a Veteran',
  'transitioning out of uniform',
  'equine therapy near you',
];

export default function WizardWelcome({ onStart, onSkip }) {
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [fading, setFading]           = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setFading(true);
      setTimeout(() => {
        setPhraseIndex(i => (i + 1) % PHRASES.length);
        setFading(false);
      }, 320);
    }, 2800);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={styles.stepWrap}>
      <p className={styles.eyebrow}>Canada's Veteran & Family Resource Directory</p>

      <h1 className={styles.title}>
        Find the right support<br />
        for <em>your situation.</em>
      </h1>

      <div className={styles.rotatingLine}>
        <span className={styles.rotatingPrefix}>Find assistance for</span>
        <span className={`${styles.rotatingWord} ${fading ? styles.fade : ''}`}>
          {PHRASES[phraseIndex]}
        </span>
      </div>

      <p className={styles.sub}>
        Signal Post connects Veterans, families, and caregivers with verified programs
        across Canada — free to use, no account needed.
      </p>

      <button className={styles.btnPrimary} onClick={onStart}>
        Help me find something →
      </button>

      <p className={styles.orLine}>or</p>

      <button className={styles.btnText} onClick={onSkip}>
        Browse all 118+ programs
      </button>
    </div>
  );
}
